'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled from 'styled-components';
import { colors } from '../Colors/index.js';
import { ResumeItemWrapper } from './ResumeItem/ResumeItem.css.js';

var AIReviewCVWrapper = styled.div({
    padding: 16
});
var CVSelectWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    @media screen and (max-width: 768px) {\n        padding-bottom: 106px;\n    }\n"], ["\n    @media screen and (max-width: 768px) {\n        padding-bottom: 106px;\n    }\n"])));
var AIReviewCVContainer = styled.div({
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    columnGap: 24
});
var ResumeList = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin: 8px 0;\n    ", " {\n        margin-bottom: 8px;\n    }\n"], ["\n    margin: 8px 0;\n    ", " {\n        margin-bottom: 8px;\n    }\n"])), ResumeItemWrapper);
({
    color: colors.error[40],
    marginTop: 8
});
var LeftSection = styled.div({
    width: 440,
    padding: '12px 16px',
    background: colors.neutral[99],
    borderRadius: 12
});
var RightSection = styled.div({
    padding: '12px 0'
});
var CTAWrapper = styled.div({
    padding: 24,
    borderTop: "1px solid ".concat(colors.grey[95]),
    textAlign: 'right'
});
var templateObject_1, templateObject_2;

export { AIReviewCVContainer, AIReviewCVWrapper, CTAWrapper, CVSelectWrapper, LeftSection, ResumeList, RightSection };
//# sourceMappingURL=AIReviewCV.css.js.map
